import React from 'react';

const Payment = () => {
    return (
        <div>
            <p className="text-3xl font-bold text-gray-700">Payment system coming soon.</p>
        </div>
    );
};

export default Payment;